function getColorNumericValue(color) {
  const canvas = createCanvas(1, 1);
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, 1, 1);
  const imageData = ctx.getImageData(0, 0, 1, 1);
  return imageData.data[0] * 65536 + imageData.data[1] * 256 + imageData.data[2];
}
const isBackgroundColor = (backgroundColor, imageData) => {
  const backgroundNumeric = getColorNumericValue(backgroundColor);
  return (x, y) => {
    const index = (y * imageData.width + x) * 4;
    const pixelNumericColor = imageData.data[index] * 65536 + imageData.data[index + 1] * 256 + imageData.data[index + 2];
    return pixelNumericColor === backgroundNumeric;
  };
};
const isTransparentColor = imageData => (x, y) => {
  const index = (y * imageData.width + x) * 4;
  const pixelAlphaValue = imageData.data[index + 3];
  return pixelAlphaValue === 0;
};
export function getCroppedCanvas(canvas, backgroundColor) {
  const originalCtx = canvas.getContext('2d', {
    willReadFrequently: true
  });
  const originalWidth = canvas.width;
  const originalHeight = canvas.height;
  const imageData = originalCtx.getImageData(0, 0, originalWidth, originalHeight);
  const isBackground = backgroundColor ? isBackgroundColor(backgroundColor, imageData) : isTransparentColor(imageData);
  let minX = originalWidth + 1,
    maxX = -1,
    minY = originalHeight + 1,
    maxY = -1,
    x = 0,
    y = 0;
  for (y = 0; y < originalHeight; y++) {
    for (x = 0; x < originalWidth; x++) {
      if (!isBackground(x, y)) {
        if (minX > x) {
          minX = x;
        }
        if (maxX < x) {
          maxX = x;
        }
        if (minY > y) {
          minY = y;
        }
        if (maxY < y) {
          maxY = y;
        }
      }
    }
  }
  const croppedWidth = maxX - minX;
  const croppedHeight = maxY - minY;
  if (croppedWidth < 0 || croppedHeight < 0) {
    return null;
  }
  const cuttedImageData = originalCtx.getImageData(minX, minY, croppedWidth, croppedHeight);
  const croppedCanvas = document.createElement('canvas'),
    croppedCtx = croppedCanvas.getContext('2d');
  croppedCanvas.width = croppedWidth;
  croppedCanvas.height = croppedHeight;
  if (backgroundColor) {
    croppedCtx.fillStyle = backgroundColor;
    croppedCtx.fillRect(0, 0, croppedWidth, croppedHeight);
  } else {
    croppedCtx.clearRect(0, 0, croppedWidth, croppedHeight);
  }
  croppedCtx.putImageData(cuttedImageData, 0, 0);
  return croppedCanvas;
}
export function createCanvas(width, height, dpi) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  if (dpi) {
    const ctx = canvas.getContext('2d', {
      willReadFrequently: true
    });
    ctx == null || ctx.scale(dpi, dpi);
  }
  return canvas;
}
export function createCanvasFromDataUrl(dataUrl, backgroundColor) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = createCanvas(img.width, img.height);
      const ctx = canvas.getContext('2d', {
        willReadFrequently: true
      });
      if (backgroundColor) {
        ctx.fillStyle = backgroundColor;
        ctx.fillRect(0, 0, img.width, img.height);
      }
      ctx == null || ctx.drawImage(img, 0, 0);
      resolve(canvas);
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}
export function getScaledCanvas(canvas, widthLimit, heightLimit, backgroundColor) {
  const originalWidth = canvas.width;
  const originalHeight = canvas.height;
  const widthRatio = widthLimit ? widthLimit / originalWidth : 1;
  const heightRatio = heightLimit ? heightLimit / originalHeight : 1;
  const ratio = Math.min(heightRatio, widthRatio);
  const width = originalWidth * ratio;
  const height = originalHeight * ratio;
  const scaledCanvas = createCanvas(width, height);
  const ctx = scaledCanvas.getContext('2d');
  if (backgroundColor && ctx) {
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, width, height);
  }
  ctx == null || ctx.drawImage(canvas, 0, 0, originalWidth, originalHeight, 0, 0, width, height);
  return scaledCanvas;
}
export function resizeCanvas(canvas, pad) {
  const ctx = canvas.getContext('2d');
  const width = canvas.offsetWidth;
  const height = canvas.offsetHeight;
  const dpi = Math.max(window.devicePixelRatio || 1, 1);
  const newWidth = width * dpi;
  const newHeight = height * dpi;
  if ((canvas.width !== newWidth || canvas.height !== newHeight) && ctx) {
    canvas.width = newWidth;
    canvas.height = newHeight;
    ctx.scale(dpi, dpi);
    pad == null || pad.redraw();
    return true;
  }
  return false;
}
//# sourceMappingURL=canvas.js.map